/**
 * Valid column types to be used for a call to newTable.
 */
export class NewTableColumnTypes {
  static INTEGER = 'int';

  static LONG = 'long';

  static DOUBLE = 'double';

  static BOOLEAN = 'bool';

  static STRING = 'string';

  static DATE_TIME = 'datetime';

  static LOCAL_TIME = 'localtime';
}

export default NewTableColumnTypes;
